<app-events-table-server [mode]="eventsTableMode.agent" [baseFilter]="baseFilter"
  [refMonth]="refMonth.toString()"></app-events-table-server>